<div class="container-fluid complyon-page reports-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell reports-shell mx-auto">
    <div class="mb-3">
      <h1 class="complyon-title reports-title mb-2 text-l">Board & audit packs</h1>
      <p class="complyon-subtitle reports-subtitle mb-0 text-s">Evidence-backed packs assembled live from across the platform - each section pulls from its source module so the numbers are always current.</p>
    </div>

    <div class="row g-3 mb-3">
      <div v-for="card in summary_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
        <div class="complyon-card rounded-4 p-3 h-100">
          <div class="text-uppercase text-xs text-secondary fw-semibold">{{ card.label }}</div>
          <div class="text-l fw-bold mt-1" :class="card.tone === 'success' ? 'text-success' : card.tone === 'warning' ? 'text-warning-emphasis' : card.tone === 'danger' ? 'text-danger' : 'text-info'">{{ card.value }}</div>
          <div class="text-xs text-secondary mt-3">{{ card.note }}</div>
        </div>
      </div>
    </div>

    <div class="complyon-panel rounded-4 overflow-hidden mb-3">
      <div class="d-flex flex-column flex-md-row align-items-md-start justify-content-between gap-3 px-3 px-md-4 pt-3 pt-md-4 pb-3">
        <div>
          <div class="complyon-section-title text-s">Board & audit packs</div>
          <div class="complyon-section-subtitle text-xs">Evidence-backed packs assembled live from across the platform - each section pulls from its source module so the numbers are always current.</div>
        </div>
        <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2" @click="new_pack">
          <i class="bi bi-plus-lg"></i>
          <span>New pack</span>
        </button>
      </div>

      <div class="px-3 px-md-4 pb-3 pb-md-4">
        <div class="row g-3">
          <div v-for="pack in pack_catalog" :key="pack.key" class="col-12 col-xl-6">
            <div
              class="complyon-card rounded-4 p-3 h-100"
              role="button"
              tabindex="0"
              @click="open_pack(pack.key)"
              @keydown.enter="open_pack(pack.key)"
              @keydown.space.prevent="open_pack(pack.key)"
            >
              <div class="d-flex align-items-start justify-content-between gap-3 pb-3 border-bottom">
                <div class="d-flex align-items-start gap-3 min-w-0">
                  <div class="d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3 bg-info-subtle text-info-emphasis" style="width: 2rem; height: 2rem;">
                    <i class="bi" :class="pack.icon"></i>
                  </div>
                  <div class="min-w-0">
                    <div class="fw-semibold text-s">{{ pack.title }}</div>
                    <div class="text-xs text-secondary">{{ pack.subtitle }}</div>
                  </div>
                </div>
                <span class="badge rounded-pill" :class="pack.status_class">{{ pack.status }}</span>
              </div>

              <div class="pt-3">
                <div class="d-flex flex-column gap-2">
                  <div v-for="item in pack.items" :key="`${pack.key}-${item.label}`" class="d-flex align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center gap-2 min-w-0">
                      <span class="rounded-circle flex-shrink-0" :class="item.tone === 'success' ? 'bg-success' : item.tone === 'warning' ? 'bg-warning' : 'bg-danger'" style="width: 7px; height: 7px;"></span>
                      <div class="text-truncate">{{ item.label }}</div>
                    </div>
                    <div class="text-xs text-secondary text-end">{{ item.source }}</div>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center justify-content-between gap-2 pt-3 mt-3 border-top">
                <div class="text-xs text-secondary">{{ pack.owner }}</div>
                <button type="button" class="btn btn-link text-decoration-none p-0 d-inline-flex align-items-center gap-1 text-success fw-semibold" @click.stop="open_pack(pack.key)">
                  <span>{{ pack.action_label }}</span>
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="active_pack" class="complyon-panel rounded-4 overflow-hidden">
      <div class="d-flex align-items-start justify-content-between gap-3 px-3 px-md-4 pt-3 pt-md-4 pb-3">
        <div>
          <div class="complyon-section-title text-s">{{ active_pack.title }}</div>
          <div class="complyon-section-subtitle text-xs">{{ active_pack.summary }}</div>
        </div>
        <span class="badge rounded-pill" :class="active_pack.status_class">{{ active_pack.status }}</span>
      </div>

      <div class="px-3 px-md-4 pb-3">
        <div class="d-flex flex-wrap gap-3 text-xs">
          <div v-for="meta in active_pack.meta" :key="`${active_pack.title}-${meta.label}`">{{ meta.label }}</div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table complyon-table align-middle mb-0">
          <thead>
            <tr>
              <th class="ps-3 text-xs">Section</th>
              <th class="text-xs">Source</th>
              <th class="text-xs">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="section in active_pack.sections" :key="`${active_pack.title}-${section.label}`">
              <td class="ps-3 fw-semibold">{{ section.label }}</td>
              <td>{{ section.source }}</td>
              <td>
                <span class="badge rounded-pill" :class="section.status_class">{{ section.status }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-wrap gap-2 px-3 px-md-4 py-3">
        <button
          v-for="action in active_pack.actions"
          :key="`${active_pack.title}-${action.label}`"
          type="button"
          class="btn d-inline-flex align-items-center gap-2"
          :class="action.variant === 'primary' ? 'config-navbar-primary-action' : 'btn-outline-secondary'"
        >
          <i class="bi" :class="action.icon"></i>
          <span>{{ action.label }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
